import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import RightExerciseTypeForm from '../Forms/RightExerciseTypeForm';

const AddEditRightExerciseTypeModal = ({
	dataRightExerciseType,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Ejercicio de Derecho
			</ModalHeader>

			<RightExerciseTypeForm
				dataRightExerciseType={dataRightExerciseType}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditRightExerciseTypeModal;
